export default __webpack_public_path__ + "static/media/delete.cd46428a.svg";